import {
    getColumnBandClass,
    getGapSplitStyle,
    isStepWidthTrack,
} from '../utils'
import styles from '../../ProjectStoryMapBoard.module.css'

const ColumnBandCells = ({ tracks, keyPrefix }) =>
    tracks.map((track, trackIndex) => {
        if (isStepWidthTrack(track)) {
            const bandClass = getColumnBandClass(tracks, trackIndex, styles)
            return (
                <div
                    key={`${keyPrefix}-${
                        track.type === 'step' ? track.step.id : `empty-${trackIndex}`
                    }`}
                    className={`${styles.columnBand} ${bandClass}`}
                />
            )
        }

        return (
            <div
                key={`${keyPrefix}-gap-${trackIndex}`}
                className={`${styles.columnBand} ${styles.columnGapSplit}`}
                style={getGapSplitStyle(tracks, trackIndex, styles)}
            />
        )
    })

export default ColumnBandCells
